// extracted by mini-css-extract-plugin
module.exports = {"radar":"styles_radar__2nW_l","noData":"styles_noData__3fCn7"};